import script from "./radio-button.vue?vue&type=script&lang=ts&setup=true"
export * from "./radio-button.vue?vue&type=script&lang=ts&setup=true"

import "./radio-button.vue?vue&type=style&index=0&id=9263b18e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9263b18e"]])

export default __exports__